import * as actionTypes from './actionTypes';
import  {getCartDevices, removeCartDevices, addCartDevices } from '../../services/cartDevices';

export const addToCart = (obj) => {
    return {
        type: actionTypes.ADD_TO_CART,
        payload: obj,
      
    }
}

export const updateCartPayment = (obj) => {
    return {
        type: actionTypes.UPDATE_CART_PAYMENT,
        payload: obj
    }
   
}

export const updateCartAddress = (obj) => {
    return {
        type: actionTypes.UPDATE_CART_ADDRESS,
        payload: obj
    }
}

export const removeToCart = (obj) => {
    return {
        type: actionTypes.REMOVE_TO_CART,
        payload: obj
    }
}

export const updateQuantityToCart = (obj) => {
    return {
        type: actionTypes.UPDATE_QUANTITY,
        payload: obj
    }
}

export const clearCartItem = () => {
    return {
        type: actionTypes.CLEAR_CART_ITEM,
    }
}

export const updateTotalPayment = (obj) => {
    return {
        type: actionTypes.UPDATE_TOTAL_PAYMENT,
        payload: obj
    }
}


